import React, { Component } from 'react'
import { connect } from 'react-redux'
import { withRouter } from 'react-router-dom'
import $ from 'jquery'
import Select from 'react-select';
import { getEmpresaSelecionada } from '../../util/empresaSelecionada'
import alterarEmpresaSelecionada from '../../actions/empresa/alterarEmpresaSelecionada'
import buscarEmpresas from '../../actions/empresa/buscarEmpresas';

export class CampoSelecionarEmpresa extends Component {
  constructor (props) {
    super(props);
    this.handleEmpresaChange = this.handleEmpresaChange.bind(this);

    this.refAutoComplete = React.createRef()
  }

  // Usa o cache do sessionStorage só para lembrar QUAL empresa (pelo id) estava
  // selecionada -- os dados dela vêm sempre da lista recém-buscada da API, nunca
  // do objeto cacheado (que pode estar desatualizado, ex.: flags de gateway de
  // pagamento habilitadas/desabilitadas depois que o cache foi gravado).
  determinaEmpresaSelecionada () {
    const empresas = this.props.empresas || [];
    const empresaSelecionadaCache = getEmpresaSelecionada();
    const empresaAtualizada = empresaSelecionadaCache
      && empresas.find(e => e.id === empresaSelecionadaCache.id);

    return empresaAtualizada || empresas[0] || null
  }

  componentDidMount () {
    this.props.buscarEmpresas().then(() => {
      if (this.props.authentication.isAuthenticated) {
        this.props.alterarEmpresaSelecionada(this.determinaEmpresaSelecionada());
        // this.refNav.current.addEventListener("shown.bs.dropdown", this.handleClick.bind(this))
        $('#dropdownGrupos')
          .on('shown.bs.dropdown', this.handleClick.bind(this))
      }
    });
  }

  componentDidUpdate (prevProps) {
    if (prevProps.authentication !== this.props.authentication && this.props.authentication.isAuthenticated) {
      this.props.buscarEmpresas().then(() => {
        this.props.alterarEmpresaSelecionada(this.determinaEmpresaSelecionada());
        $('#dropdownGrupos')
          .on('shown.bs.dropdown', this.handleClick.bind(this))
      });
    }
  }

  // eslint-disable-next-line class-methods-use-this
  handleEmpresaChange (empresa) {
    const emp = this.props.empresas.filter(f=>f.id === empresa.value)[0]
    this.props.alterarEmpresaSelecionada(emp)
  }

  possuiGrupos () {
    return this.props.empresas && this.props.empresas.length
  }

  isMostraAutocomplete () {
    return (this.props.empresas.length > 10)
  }

  handleClick (event) {
    if (this.refAutoComplete.current) {
      this.refAutoComplete.current.getWrappedInstance()
        .focus(event)
    }
  }

  render () {
    if (!this.possuiGrupos() || !this.props.empresaSelecionada) {
      return <div>Carregando...</div>
    }

    return (
      <React.Fragment>
      <label>Empresa</label>
      <Select
        maxMenuHeight={400}
        menuPlacement="auto"
        noOptionsMessage={() => ('Nenhuma opção encontrada')}
        placeholder='Selecione uma empresa'
        options={this.props.empresas.map(elemento => ({
          label: elemento.nomeFantasia,
          value: elemento.id
        }))}
        value={this.props.empresaSelecionada ? ({
          label: this.props.empresaSelecionada.nomeFantasia,
          value: this.props.empresaSelecionada.id
        }) : ''}
        onChange={value => this.handleEmpresaChange(value)}
      />
      </React.Fragment>
    )
  }
}

export function mapStateToProps (state) {
  return {
    empresas: state.empresas,
    empresaSelecionada: state.empresaSelecionada,
    authentication: state.authentication,
  }
}

export default withRouter(connect(mapStateToProps, { alterarEmpresaSelecionada, buscarEmpresas })(CampoSelecionarEmpresa))
